export enum AppointmentStatus {
  booked = 'booked',
  completed = 'completed',
  cancelled = 'cancelled',
  // Not a real status, used notify about appointment update
  rescheduled = 'rescheduled',
}
